
export const nextNetworkingApis = ({fetcher})=>({
    validateUrl: async ({url}) => {
        // response: {
        //   "success": true,
        //   "message": "URL is valid."
        // }
        return fetcher.postJson("/next-api/authenticate/validate_url", {url});
    },

});

